export default __webpack_public_path__ + "img/Download_on_the_Google_Play_Store.svg";